import { UserInfo } from 'auth/types/user-info.type';
import { WebSealUserInfoResponseViewModel } from 'bff';

export const mapWebSealUserToUserInfo = (
  webSealUser: WebSealUserInfoResponseViewModel
): UserInfo => ({
  sub: webSealUser.sub,
  name: webSealUser.name,
  email: webSealUser.email,
  given_name: webSealUser.givenName,
  family_name: webSealUser.familyName,
  display_name: webSealUser.displayName,
  preferred_username: webSealUser.intermediaryCode,
  guid: '',
  phone_number: '',
  login: '',
  groups: '',
  nickname: ''
});
